import React from "react";
import { Navigate } from "react-router-dom";
import AUD from "../../images/AUD.png";
import MusicController from "../bars/MusicController";
import EntryFavoriteToggleIcon from "../shared/EntryFavoriteToggleIcon";
import EntryImage from "../shared/EntryImage";
import EntryTags from "../shared/EntryTags";
import EntryVenueCoverageMultiline from "../shared/EntryVenueCoverageMultiline";
import { AudioControls } from "../shared/useAudioControls";
import { useNavUtils } from "../shared/useNavUtils";
import "./MobilePlayer.scss";

const MobilePlayer: React.FC<{
  audioControls: AudioControls;
}> = (props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);

  const navUtils = useNavUtils();

  const entry = props.audioControls.getEntry();
  const track = props.audioControls.getTrack();

  if (!entry || !track) {
    return <Navigate to="/" replace />;
  }

  const goToEntry = () => navUtils.show(entry.identifier);

  return (
    <div className="MobilePlayer">
      <div className={entry.isSoundboard ? "hero sbd" : "hero aud"}>
        <div className="ui container grid">
          <div className="sixteen wide right aligned column">
            <i
              className="ui window close outline large icon link"
              onClick={navUtils.goBack}
            />
          </div>
          <div className="sixteen wide center aligned column">
            {entry.image ? (
              <EntryImage image={entry.image} />
            ) : (
              <img
                className="ui medium bordered image"
                src={entry.isSoundboard ? SBD : AUD}
              />
            )}
          </div>
          <div className="sixteen wide center aligned column">
            <h1 className="ui header">
              {track.title}
              {props.audioControls.isRadio() ? (
                <i
                  className="ui icon small compact link disc"
                  onClick={navUtils.radio}
                ></i>
              ) : null}
            </h1>
            <h2 className="ui header">
              <div>
                <div className="track-info" onClick={goToEntry}>
                  {entry.date}
                </div>
                <EntryFavoriteToggleIcon entry={entry} />
              </div>
              <div className="track-info" onClick={goToEntry}>
                <EntryVenueCoverageMultiline entry={entry} />
              </div>
            </h2>
            <EntryTags entry={entry} />
          </div>
          <div className="sixteen wide center aligned column controller">
            <MusicController audioControls={props.audioControls} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobilePlayer;
